class TransliterationObjet {
    id='';
    name='';
    harakaats={'key':{marker:'',value:''}};
    tanwiinats={'key':{marker:'',value:''}};
    hurufou_madd={'key':{marker:'',value:''}};
    hurufou_chamsiya={'key':{marker:'',value:''}};
    hurufou_qamariya={'key':{marker:'',value:''}};
    no_duplicables={'key':{marker:'',value:''}};

    constructor({
        id='',
        name='',
        harakaats={},
        tanwiinats={},
        hurufou_madd={},
        hurufou_chamsiya={},
        hurufou_qamariya={},
        no_duplicables={},
    }) {
        this.id = id;
        this.name = name;
        this.harakaats = harakaats;
        this.tanwiinats = tanwiinats;
        this.hurufou_madd = hurufou_madd;
        this.hurufou_chamsiya = hurufou_chamsiya;
        this.hurufou_qamariya = hurufou_qamariya;
        this.no_duplicables = no_duplicables;
    }

    getAllHarakaats() {
        return { ...this.tanwiinats,...this.harakaats,...this.hurufou_madd, };
    }
    getAllLetters() {
        return {
            // Lettres solaires
            ...this.hurufou_chamsiya,
            // Lettres lunaires
            ...this.hurufou_qamariya,
            // Harakaats
            ...this.getAllHarakaats()
        };
    }
}
export default TransliterationObjet;